import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import {  cpbaseUrl } from "../../Constant/Matcher";



export const channelPartnerBusinessApi = createApi({
    reducerPath: "channelPartnerbillApi",
    baseQuery: fetchBaseQuery({baseUrl: `${cpbaseUrl}`}),
    endpoints: (builder) => ({
        getBusinessPlan: builder.query({
            query: (cpid) => ({
             url: `businessplan?cpid=${cpid}`,
             method: "GET",
            })
         }),
        deleteBusinessPlan: builder.query({
            query: (cpid) => ({
             url: `recaculate-businessplan?cpid=${cpid}`,
             method: "GET",
            })
         }),
         createBusinessPlan: builder.mutation({
            query: ({cpid, data}) => ({
                url: `businessplan?cpid=${cpid}`,
                method: "POST",
                body: data
            })
            }),
         
    })
})


export const { useGetBusinessPlanQuery, useCreateBusinessPlanMutation, useDeleteBusinessPlanQuery } = channelPartnerBusinessApi